export class VenueRate {
    id!:number;
    mpid!:string;
    venueName!:string;
    venueMPID!:string;
    rate!:number;
    materialAspect!:string;
    effectiveDate!:string;
    isDeleted!:boolean;
    createdDate!:string | null;
    createdUser!:string | null;
    updatedDate!:string | null;
    updatedUser!:string | null;
}